import React, { useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import CurrencyDropdown from 'components/CurrencyDropdown';
import { filterExcludedCurrencies } from 'utils';

const CurrencySelect = ({ options, onChange, pageName, ...props }) => {
  const dropdownRef = useRef();
  const [isOpen, setIsOpenStatus] = useState(false);
  const [isFocused, setIsFocusedStatus] = useState(false);

  const [searchValue, setSearchValue] = useState('');

  const toggleDropdown = () => {
    setIsOpenStatus(!isOpen);
    setIsFocusedStatus(isOpen ? false : isFocused);
    setSearchValue('');
  };

  const items = useMemo(() => {
    return filterExcludedCurrencies(
      options.map(({ meta }) => ({
        name: meta.text,
        slug: meta.id,
        code: meta.id,
        path: meta.path,
        type: 'money',
      }))
    );
  }, [options]);

  const filteredItems = useMemo(() => {
    const res = items.filter(
      ({ name, slug }) =>
        name.toLowerCase().includes(searchValue.toLowerCase()) ||
        slug.toLowerCase().includes(searchValue.toLowerCase())
    );
    return res;
  }, [items, searchValue]);

  const onClick = event => {
    const { value } = event.currentTarget.dataset;
    const { slug } = JSON.parse(value);

    onChange(slug);
  };

  const onBlur = () => {
    setIsFocusedStatus(false);
  };

  const onSearchInputChange = event => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const onCancel = event => {
    event.stopPropagation();
    setSearchValue('');
    setIsFocusedStatus(false);
  };

  const onFocus = () => {
    setIsFocusedStatus(true);
  };

  return (
    <CurrencyDropdown
      {...props}
      dropdownRef={dropdownRef}
      toggleDropdown={toggleDropdown}
      isOpen={isOpen}
      items={filteredItems}
      onSelectOption={onClick}
      onSearchInputChange={onSearchInputChange}
      searchValue={searchValue}
      pageName={pageName}
      isFocused={isFocused}
      onCancel={onCancel}
      onBlur={onBlur}
      onFocus={onFocus}
      isLocalSearch
    />
  );
};

export default CurrencySelect;

CurrencySelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func.isRequired,
  titleExtractor: PropTypes.string,
  isButtonMode: PropTypes.bool,
  pageName: PropTypes.string,
};
CurrencySelect.defaultProps = {
  options: [],
  titleExtractor: undefined,
  isButtonMode: false,
  pageName: null,
};
